interface Map {
  [key: string]: string | undefined;
}

type ITidBitBullet = {
  variant: string;
};

const COLOR_THEME: Map = {
  light: "#CFD3E5",
  dark: "#10247E",
};

const TidbitBullet = ({ variant }: ITidBitBullet): JSX.Element => {
  return (
    <div className="h-[1.125rem] w-[1.125rem]">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.28171"
          y="5.74294"
          width="10.8993"
          height="10.8993"
          rx="1"
          transform="rotate(-20 1.28171 5.74294)"
          stroke="#707CB2"
          strokeWidth="2"
        />
        <path
          d="M6.35938 6.88985L9.40425 10.2321L16.2254 2.35132"
          stroke={COLOR_THEME[variant] ?? COLOR_THEME["dark"]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default TidbitBullet;
